<template>
  <div>
    <div>
      <div class="shift-wrapper">
        <div class="list-block">
          <Table
            :clickHighlight="false"
            :columns="columns"
            :rows="rows"
            :filter="{}"
            :loading-instance="loadingInstance"
            :set-loading-instance="setLoadingInstance"
            :pagination="false"
            tableName="shiftPlansTable"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Table from '../../../common/table';

export default {
  title: 'ShiftbaseTable',
  components: { Table },
  props: {
    userLineSize: {
      type: Number,
      default: 0
    },
    shift: {
      type: Object,
      default: () => {}
    },
    selectSell: {
      type: Function,
      default: () => {}
    },
    selectShiftLog: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      loadingInstance: null,
      columns: [
        {
          field: 'dateFormated',
          title: this.$translate('Date'),
          key: '1',
          align: 'left'
        },
        {
          field: 'shiftFormated',
          title: this.$translate('Shift'),
          key: '2',
          align: 'left'
        },
        {
          field: 'team',
          title: this.$translate('Team'),
          key: '3',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return row.team.name;
          }
        },
        {
          field: 'actions',
          title: this.$translate('Actions'),
          key: '4',
          align: 'left',
          width: 150,
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <b-button variant="primary" size="sm" on-click={() => this.selectSell(row.cellsByUserID[row.team.id], row.date, row.team.id)}>
                  {this.$translate('Shiftplan')}
                </b-button>
                <b-button
                  variant="primary"
                  size="sm"
                  style="margin-left:15px;white-space: nowrap;"
                  on-click={() => this.selectShiftLog(row.date, row.team.id)}
                >
                  {this.$translate('Shift Log')}
                </b-button>
              </div>
            );
          }
        }
      ]
    };
  },
  computed: {
    rows: function() {
      const data = [];
      console.log(this.shift, 'shift');
      if (!this.shift) {
        return [];
      }

      this.shift.columns.forEach(column => {
        this.shift.users.forEach(u => {
          data.push({
            date: column.date,
            dateFormated: moment(column.date).format('DD.MM.YYYY'),
            shift: column.cellsByUserID[u.id],
            shiftFormated: this.$translate(column.cellsByUserID[u.id]),
            team: u,
            cellsByUserID: column.cellsByUserID
          });
        });
      });
      console.log(data, 'data');
      return data;
    }
  },
  methods: {
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    }
  }
};
</script>

<style lang="scss" scoped>
.list-block {
  flex-direction: column;
}
.user-line-block {
  display: flex;
}
.shiftplane-btn {
  color: white;
  background: linear-gradient(#2260ff, #2260ff);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.shift-log-btn {
  border: 1px solid #2260ff !important;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-block {
  display: flex;
}
</style>
